module.exports = __webpack_public_path__ + "assets/img/standart.ea3b86f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/standart.svg
// module id = ftnl
// module chunks = 0